import { Pipe, PipeTransform } from '@angular/core';

export interface Filter {
  type: string;
}

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform(items: any[], filter: Filter ): any {
    return items.filter((listing: any) => listing.type === filter.type);
  }

}
